import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-block bg-forest hover:bg-forest-dark text-white font-semibold text-base py-3 px-6 rounded-lg transition-colors duration-300 text-center shadow-md';
  const isExternal = href && !href.startsWith('#') && !href.startsWith('/');
  if (href) {
    return <a href={href} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className={`${baseStyles} ${className}`} onClick={onClick} data-id="element-14">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} onClick={onClick} {...props} data-id="element-15">
      {children}
    </button>;
}